// extracted by mini-css-extract-plugin
export default {"page":"Login_page__KUlFB","form":"Login_form__x+47F"};